
export function capitalizeWords(str?: string | null) {
    if (str === undefined || str === null) {
        return ''
    }

    return str.toUpperCase()
    
    // return str
    //     .toLowerCase()
    //     .split(' ')
    //     .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
    //     .join(' ')
}

export function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
}
